import decodePolyline from 'decode-google-map-polyline'
import GeoJSON from 'geojson'

function mapAgency(agency) {
  return {
    name: agency.name,
    phone: agency.phone,
    url: agency.url
  }
}

function mapVehicle(vehicle) {
  return {
    name: vehicle.name,
    type: vehicle.type,
    icon: vehicle.icon,
    local_icon: vehicle.local_icon
  }
}

function mapAgencies(agencies) {
  return _.map(agencies, agency => mapAgency(agency))
}

function mapLine(line) {
  const lineData = {
    color: line.color,
    name: line.name,
    short_name: line.short_name,
    text_color: line.text_color,
    url: line.url,
    icon: line.icon
  }

  if (line.agencies) {
    lineData.agencies = mapAgencies(line.agencies)
  }

  if (line.vehicle) {
    lineData.vehicle = mapVehicle(line.vehicle)
  }

  return lineData
}

function mapTransit(transit) {
  const transitData = {
    arrival_stop: transit.arrival_stop,
    arrival_time: transit.arrival_time,
    departure_stop: transit.departure_stop,
    departure_time: transit.departure_time,
    headsign: transit.headsign,
    headway: transit.headway,
    num_stops: transit.num_stops,
    trip_short_name: transit.trip_short_name
  }

  if (transit.line) {
    transitData.line = mapLine(transit.line)
  }

  return transitData
}

function mapSteps(steps) {
  return _.map(steps, step => {
    const points = decodePolyline(step.encoded_lat_lngs)

    const stepData = {
      distance: step.distance,
      duration: step.duration,
      end_point: points[points.length - 1],
      polyline: decodePolyline(step.polyline.points),
      start_point: points[0],
      travel_mode: step.travel_mode,
      style: {}
    }

    const polylineData = _.map(stepData.polyline, item => ([item.lng, item.lat]))
    if (polylineData.length === 0) {
      stepData.polyline = undefined
    }
    const dataPoints = {
      polyline: polylineData
    }
    const geojson = GeoJSON.parse(dataPoints, {LineString: 'polyline'})
    stepData.polyline = geojson

    if (step.steps) {
      stepData.steps = mapSteps(step.steps)
    }

    if (step.travel_mode === 'TRANSIT') {
      stepData.transit = mapTransit(step.transit)
    }

    return stepData
  })
}

function mapLeg(leg) {
  const legData = {
    arrival_time: leg.arrival_time,
    departure_time: leg.departure_time,
    distance: leg.distance,
    duration: leg.duration,
    end_address: leg.end_address,
    start_address: leg.start_address,
    steps: mapSteps(leg.steps),
    stops: []
  }

  _.each(legData.steps, step => {
    if (!_.includes(legData.stops, step.start_point)) {
      step.name = legData.start_address
      legData.stops.push(step.start_point)
    }
    if (!_.includes(legData.stops, step.end_point)) {
      step.name = legData.end_address
      legData.stops.push(step.end_point)
    }
  })
  return legData
}

function mapFare(fareData) {
  return {
    currency: fareData.currency,
    value: fareData.value,
    text: fareData.text
  }
}

function mapRoute(route) {
  const routeData = {
    copyrights: route.copyrights,
    polyline: decodePolyline(route.overview_polyline),
    warnings: route.warnings,
    leg: mapLeg(route.legs[0]),
    fare: route.fare
  }

  const polylineData = _.map(routeData.polyline, item => ([item.lat, item.lng]))
  if (polylineData.length === 0) {
    routeData.polyline = undefined
  }
  const dataPoints = {
    polyline: polylineData
  }
  routeData.polyline = GeoJSON.parse(dataPoints, {LineString: 'polyline'})

  if (route.fare) {
    routeData.fare = mapFare(route.fare)
  }

  return routeData
}

function mapRoutes(routes) {
  return _.map(routes, route => mapRoute(route))
}

export default {
  /*
   * Solicita las rutas disponibles entre 2 direcciones (origen y destino).
   * DOCUMENTACIÓN DE LA VERSIÓN LIBRERÍA (SI NOS HA FUNCIONADO)
   *  https://developers.google.com/maps/documentation/javascript/directions
   * Decodificador de Polilíneas usado:
   *  https://www.npmjs.com/package/decode-google-map-polyline
   * Documentación de la versión API (NO NOS HA FUNCIONADO)
   * Documentación:
   *  https://developers.google.com/maps/documentation/directions/intro#DirectionsRequests
   * Parámetros:
   *  - origin
   *  - destination
   *  - key: API KEY de Google
   *  - mode: transit (transporte público). Si el modo es transporte público permite usar los
   *          parámetros departure_time, arrival_time, transit_mode y transit_routing_preference.
   *  - waypoints: puntos de ruta intermedios.
   *  - alternatives: true (varias rutas alternativas)
   *  - avoid: permite evitar determinados elementos. Admite tolls, highways, ferries e indoor.
   *  - language: idioma de la petición (https://developers.google.com/maps/faq#languagesupport)
   *  - units: unidad de medida. Admite metric o imperial.
   *           (https://developers.google.com/maps/documentation/directions/intro#UnitSystems)
   *  - region: código de la región (https://en.wikipedia.org/wiki/CcTLD,
   *            https://en.wikipedia.org/wiki/List_of_Internet_top-level_domains)
   *  - transit_mode: tipo de medio de transporte (bus, subway, train, tram, rail)
   *  - transit_routing_preference: (less_walking, fewer_transfers)
   */
  index(options) {
    const directionsService = new google.maps.DirectionsService()

    const params = _.merge(
      {
        travelMode: google.maps.DirectionsTravelMode.TRANSIT,
        provideRouteAlternatives: true,
        unitSystem: google.maps.UnitSystem.METRIC,
        transitOptions: {
          modes: [google.maps.TransitMode.BUS]
        },
        region: Vue.store.state.country.alpha2
      },
      options
    )

    return new Promise((resolve, reject) => {
      directionsService.route(params, (response, status) => {
        if (status === 'OK') {
          response.routes = mapRoutes(response.routes)
          resolve(response)
        } else {
          reject(status)
        }
      })
    })
  }
}
